import { literal, nullable, number, struct, tuple, union } from 'io-ts/lib/Decoder';

import { iotsUtils } from '@bedc/core';

export const DateFilter = union(
	struct({
		rangeType: literal('between'),
		values: tuple(iotsUtils.ValidDate, nullable(iotsUtils.ValidDate)),
	}),
	struct({
		rangeType: literal('past'),
		amount: number,
		metric: union(
			literal('days'),
			literal('weeks'),
			literal('months'),
			literal('calendar-month')
		),
	})
);
